import { CloseButton, Group, Table } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useOrganisation } from '../../../hooks/useOrganisation';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { OperatorDto } from '../types/OperatorDto';
import { KeyedRow } from '../../../components/KeyedRow';

export function StaffListRow({ operator }: { operator: OperatorDto }) {
	const navigate = useNavigate();
	const organisation = useOrganisation();

	return (
		<>
			<KeyedRow>
				<Table.Td>{undefinedCheck(operator.username)}</Table.Td>
				<Table.Td>{undefinedCheck(operator.firstName)}</Table.Td>
				<Table.Td>{undefinedCheck(operator.surname)}</Table.Td>
				<Table.Td>{undefinedCheck(operator.jobTitle)}</Table.Td>
				<Table.Td>{undefinedCheck(operator.cardNo)}</Table.Td>
				<Table.Td>{undefinedCheck(operator.branch)}</Table.Td>
				<Table.Td>
					{!operator.enrolled ? <>Not Enrolled</> : <>Enrolled</>}
				</Table.Td>
				<Table.Td>
					{!operator.clockedIn ? <>Clocked Out</> : <>Clocked In</>}
				</Table.Td>
				<Table.Td>
					<Group align={'center'}>
						<CloseButton
							icon={<IconArrowRight {...defaultIconStyle} />}
							onClick={() =>
								navigate(`/${organisation.get()}/staff/member/${operator.id}`)
							}
						/>
					</Group>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
